import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import Select from 'react-select';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'

const RentadoraComponent = ({ rentadoras, rentadora, contrato, modificarRentadora, handleChangeRentadora, handleChangeContrato,
                              rentadoraLoading, handleAgregarRentadora, validationErrors }) => {
    const intl = useIntl();
    const esObligatoria = ConfigBusiness.get('moviles.rentadora.obligatorio') === 'true';

    return (
        <div className="card pull-up">
            <div className="card-content">
                <div className="card-body">
                    <h4 className="form-section mt-2">
                        <i class="las la-key"></i>
                        {intl.formatMessage({ id: "movilesAbm.render.rentadora.rentadora", defaultMessage: "Renting" })}
                    </h4>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-md-6 label-control col-form-label" htmlFor="rentadora">
                                    {intl.formatMessage({ id: "movilesAbm.render.rentadora.rentadora", defaultMessage: "Rentadora" })} :
                                    { esObligatoria ? <span className="text">*</span>: null}
                                </label>
                                <div className="col-md-6">
                                    {modificarRentadora ?
                                        (
                                        <div >
                                            <div className="col-md-8" style = {{display: "inline-table", padding: 0}}>
                                                <Select
                                                id="rentadora"
                                                name="rentadora"
                                                placeholder={!rentadoraLoading ? intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_rentadora', defaultMessage: 'Seleccione' }) : ''}
                                                options={rentadoras}
                                                valueKey='id'
                                                labelKey='descripcion'
                                                value={rentadora ? rentadora : null}
                                                onChange={(e) => handleChangeRentadora(e)}
                                                isLoading={rentadoraLoading}
                                                disabled={rentadoraLoading}
                                                className={esObligatoria && validationErrors.rentadora ? 'is-invalid' : ''}
                                                />
                                            </div>
                                            <div className="col-md-1" style = {{display: "inline-table",  'paddingRight': 0 + "px"}}>
                                                <button type="button" className="btn btn-primary" onClick={(e)=>handleAgregarRentadora(e)}>+</button>
                                            </div>
                                            { esObligatoria && validationErrors.rentadora &&
                                                <div>
                                                    <br/>
                                                    <small className="text-danger">{validationErrors.rentadora}</small>
                                                </div>
                                            }
                                        </div>
                                        ) : (<div className="form-control-static col-form-label form-value">{rentadora ? rentadora.descripcion : ''}</div>)}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-md-6 label-control col-form-label" htmlFor="nro_cuotas_leasing">
                                    {intl.formatMessage({ id: "movilesAbm.render.rentadora.nroCuotasLeasing", defaultMessage: "Nº de cuotas leasing" })} :
                                </label>
                                <div className="col-md-6">
                                    {modificarRentadora ?
                                        (<div>
                                            <input 
                                                className={validationErrors.nro_cuotas_leasing ? "form-control is-invalid" : "form-control"}
                                                placeholder="0"
                                                id="nro_cuotas_leasing"
                                                name="nro_cuotas_leasing"
                                                value={contrato.nro_cuotas_leasing}
                                                onChange={(e) => handleChangeContrato('nro_cuotas_leasing', e.target.value)}
                                                disabled={rentadora === null}
                                            />
                                        </div>) : (<div className="form-control-static col-form-label form-value">{contrato.nro_cuotas_leasing ? contrato.nro_cuotas_leasing : ''}</div>)}
                                        <small className="text-danger">{validationErrors.nro_cuotas_leasing}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-md-6 label-control col-form-label" htmlFor="odometro_limite_contrato">
                                    {intl.formatMessage({ id: "movilesAbm.render.contrato.odometroLimiteDeContrato", defaultMessage: "Odómetro de límite contrato" })} :
                                </label>
                                <div className="col-md-6">
                                    {modificarRentadora ?
                                        (<div>
                                            <input 
                                                className={validationErrors.odometro_limite_contrato ? "form-control is-invalid" : "form-control"}
                                                placeholder="0" 
                                                id="odometro_limite_contrato" 
                                                name="odometro_limite_contrato" 
                                                value={contrato.odometro_limite_contrato}
                                                onChange={(e) => handleChangeContrato('odometro_limite_contrato', e.target.value)}
                                                disabled={rentadora === null}
                                            />
                                        </div>) : (<div className="form-control-static col-form-label form-value">{contrato.odometro_limite_contrato ? Math.floor(contrato.odometro_limite_contrato) : ''}</div>)}
                                        <small className="text-danger">{validationErrors.odometro_limite_contrato}</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-md-6 label-control col-form-label" htmlFor="tasa_impuestos">
                                    {intl.formatMessage({ id: "movilesAbm.render.contrato.tasaImpuestos", defaultMessage: "Tasa de impuestos (%)" })} :
                                </label>
                                <div className="col-md-6">
                                    {modificarRentadora ?
                                        (<div>
                                            <input 
                                                className={validationErrors.tasa_impuestos ? "form-control is-invalid" : "form-control"}
                                                placeholder="0.00"
                                                id="tasa_impuestos"
                                                name="tasa_impuestos"
                                                value={contrato.tasa_impuestos}
                                                onChange={(e) => handleChangeContrato('tasa_impuestos', e.target.value)}
                                                disabled={rentadora === null}
                                            />
                                        </div>) :
                                        (
                                            <div className="form-control-static col-form-label form-value">{contrato.tasa_impuestos > 0 ? contrato.tasa_impuestos : ''}</div>
                                        )}
                                        <small className="text-danger">{validationErrors.tasa_impuestos}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-md-6 label-control col-form-label" htmlFor="porcentaje_alerta_utilizacion">
                                    {intl.formatMessage({ id: "movilesAbm.render.contrato.porcentajeAlertaUtilizacion", defaultMessage: "Porcentaje (%) de alerta de utilización" })} :
                                </label>
                                <div className="col-md-6">
                                    {modificarRentadora ?
                                        (<div>
                                            <input 
                                                className={validationErrors.porcentaje_alerta_utilizacion ? "form-control is-invalid" : "form-control"}
                                                placeholder="0.00"
                                                id="porcentaje_alerta_utilizacion"
                                                name="porcentaje_alerta_utilizacion"
                                                value={contrato.porcentaje_alerta_utilizacion}
                                                onChange={(e) => handleChangeContrato('porcentaje_alerta_utilizacion', e.target.value)}
                                                disabled={rentadora === null}
                                            />
                                        </div>) : (<div className="form-control-static col-form-label form-value">{contrato.porcentaje_alerta_utilizacion > 0 ? contrato.porcentaje_alerta_utilizacion : ''}</div>)}
                                        <small className="text-danger">{validationErrors.porcentaje_alerta_utilizacion}</small>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-md-6 label-control col-form-label" htmlFor="valor_cuota_depreciacion">
                                    {intl.formatMessage({ id: "movilesAbm.render.contrato.valorCuotaDeprecicion", defaultMessage: "Valor cuota depreciación" })} :
                                </label>
                                <div className="col-md-6">
                                    {modificarRentadora ?
                                        (<div>
                                            <input
                                                className={validationErrors.valor_cuota_depreciacion ? "form-control is-invalid" : "form-control"}
                                                placeholder="0.00"
                                                id="valor_cuota_depreciacion"
                                                name="valor_cuota_depreciacion"
                                                value={contrato.valor_cuota_depreciacion}
                                                onChange={(e) => handleChangeContrato('valor_cuota_depreciacion', e.target.value)}
                                                disabled={rentadora === null}
                                            />
                                        </div>) : (<div className="form-control-static col-form-label form-value">{contrato.valor_cuota_depreciacion > 0 ? contrato.valor_cuota_depreciacion : ''}</div>)}
                                        <small className="text-danger">{validationErrors.valor_cuota_depreciacion}</small>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-md-6 label-control col-form-label" htmlFor="kms_excedente">
                                    {intl.formatMessage({ id: "movilesAbm.render.contrato.valorKmExcedente", defaultMessage: "Valor km excedente" })} :
                                </label>
                                <div className="col-md-6">
                                    {modificarRentadora ?
                                        (<div>
                                            <input
                                                className={validationErrors.kms_excedente ? "form-control is-invalid" : "form-control"}
                                                placeholder="0"
                                                id="kms_excedente"
                                                name="kms_excedente"
                                                value={contrato.kms_excedente}
                                                onChange={(e) => handleChangeContrato('kms_excedente', e.target.value)}
                                                disabled={rentadora === null}
                                            />
                                        </div>) : (<div className="form-control-static col-form-label form-value">{contrato.kms_excedente > 0 ? Math.floor(contrato.kms_excedente) : ''}</div>)}
                                        <small className="text-danger">{validationErrors.kms_excedente}</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-md-6 label-control col-form-label" htmlFor="valor_cuota_leasing">
                                    {intl.formatMessage({ id: "movilesAbm.render.contrato.valorCuotaLeasing", defaultMessage: "Valor cuota leasing" })} :
                                </label>
                                <div className="col-md-6">
                                    {modificarRentadora ?
                                        (<div>
                                            <input
                                                className={validationErrors.valor_cuota_leasing ? "form-control is-invalid" : "form-control"}
                                                placeholder="0.00"
                                                id="valor_cuota_leasing"
                                                name="valor_cuota_leasing"
                                                value={contrato.valor_cuota_leasing}
                                                onChange={(e) => handleChangeContrato('valor_cuota_leasing', e.target.value)}
                                                disabled={rentadora === null}
                                            />
                                        </div>) : (<div className="form-control-static col-form-label form-value">{contrato.valor_cuota_leasing > 0 ? contrato.valor_cuota_leasing : ''}</div>)}
                                        <small className="text-danger">{validationErrors.valor_cuota_leasing}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-md-6 label-control col-form-label" htmlFor="nro_cuotas_depreciacion">
                                    {intl.formatMessage({ id: "movilesAbm.render.contrato.nroCuotasDepreciacion", defaultMessage: "Nº de cuotas depreciación" })} :
                                </label>
                                <div className="col-md-6">
                                    {modificarRentadora ?
                                        (<div>
                                            <input
                                                className={validationErrors.nro_cuotas_depreciacion ? "form-control is-invalid" : "form-control"}
                                                placeholder="0"
                                                id="nro_cuotas_depreciacion"
                                                name="nro_cuotas_depreciacion"
                                                value={contrato.nro_cuotas_depreciacion}
                                                onChange={(e) => handleChangeContrato('nro_cuotas_depreciacion', e.target.value)}
                                                disabled={rentadora === null}
                                            />
                                        </div>) : (<div className="form-control-static col-form-label form-value">{contrato.nro_cuotas_depreciacion > 0 ? contrato.nro_cuotas_depreciacion : ''}</div>)}
                                        <small className="text-danger">{validationErrors.nro_cuotas_depreciacion}</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-md-6 label-control col-form-label" htmlFor="valor_interes_mensual">
                                    {intl.formatMessage({ id: "movilesAbm.render.contrato.valorInteresMensual", defaultMessage: "Valor interés mensual (%)" })} :
                                </label>
                                <div className="col-md-6">
                                    {modificarRentadora ?
                                        (<div>
                                            <input
                                                className={validationErrors.valor_interes_mensual ? "form-control is-invalid" : "form-control"}
                                                placeholder="0.00"
                                                id="valor_interes_mensual"
                                                name="valor_interes_mensual"
                                                value={contrato.valor_interes_mensual}
                                                onChange={(e) => handleChangeContrato('valor_interes_mensual', e.target.value)}
                                                disabled={rentadora === null}
                                            />
                                        </div>) : (<div className="form-control-static col-form-label form-value">{contrato.valor_interes_mensual > 0 ? contrato.valor_interes_mensual : ''}</div>)}
                                        <small className="text-danger">{validationErrors.valor_interes_mensual}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
}

export default RentadoraComponent;